export default {
  map_areas: {
    'france.chambord.chateau': {
      'enceintebasse.0.accueil': 'Reception - Ticket Office',
      'courchateau.0.sud': 'Courtyard in the château',
      'donjon.0.vestibulesud': 'South cross arm',
      'donjon.0.salledeschasses': 'The hunting room',
      'donjon.0.vestibuleest': 'East cross arm',
      'donjon.0.salledesillustres': 'Hall of Fame',
      'donjon.0.vestibulenord': 'North cross arm',
      'donjon.0.salledesbourbons': 'The Bourbon room',
      'donjon.0.vestibuleouest': 'West cross arm',
      'donojon.0.salleaudiovisuelle': 'Audio-visual room',
      'enceintebasse.0.cafeorleans': "Orléans' Cafe",
      'enceintebasse.0.salledescarrosses': 'The coach room',
      'enceintebasse.0.fosselatrine': 'Pit latrines',
      'enceintebasse.0.depotlapidaire': 'Stone depot',
      'donjon.0.cuisinepolignac': '18th century kitchens',
      'enceintebasse.0.avantboutique': 'Gift shop - Exit',
      'enceintebasse.0.boutique': 'Gift shop - Exit',
      'enceintebasse.0.sortie': 'Gift shop - Exit',
      'enceintebasse.0.toilettes': 'Toilets',
      'courchateau.0.ouest': 'Courtyard in the château',
      'donjon.0.cabinetchasses': 'Hunting cabinet',
      'donjon.1.escaliers': '1st floor staircase exit',
      'donjon.1.cafemarechaldesaxe': 'West Hall',
      'donjon.1.chambredeslauriers': 'The Laurel Room ',
      'donjon.1.cabinetdetravailsudouest': 'Study ',
      'donjon.1.chambredeconti': 'Guest room',
      'donjon.1.theatredemoliere': 'The old Molière theatre',
      'donjon.1.chambrecharlesquint': 'The Count of Chambord’s museum - 1',
      'donjon.1.museecomtedechambord2': 'The Count of Chambord’s museum - 2',
      'donjon.1.museecomtedechambord3': 'The Count of Chambord’s museum - 3',
      'donjon.1.museecomtedechambord4': 'The Count of Chambord’s museum - 4',
      'donjon.1.museecomtedechambord5': 'The Count of Chambord’s museum - 5 ',
      'donjon.1.loggiaest': 'North Loggia 1st floor',
      'donjon.1.salleest': 'East Hall',
      'donjon.1.chambredeparade': 'Ceremonial bedchamber ',
      'donjon.1.salondecompagnie': 'Drawing room ',
      'donjon.1.premiereantichambre': 'First anteroom ',
      'donjon.1.loggiaouest': 'West Loggia ',
      'donjon.1.chambredelareine': 'Queen’s bedchamber ',
      'donjon.1.antichambredelareine': 'Queen’s antechamber',
      'aileroyale.1.galerieroyale': 'Gallery in the royal wing',
      'aileroyale.1.oratoire': 'Francis I’s oratory ',
      'aileroyale.1.garderobe': 'Francis I’s garderobe',
      'aileroyale.1.chambreduroi': 'Francis I’s bedchamber ',
      'aileroyale.1.cabinetdetravailduroi': 'Francis I’s study ',
      'aileroyale.1.salleduconseil': 'The King’s great hall',
      'aileroyale.1.galeriemarignan': 'Marignan Gallery',
      'ailechapelle.1.galeriechapelle': 'Chapel gallery',
      'ailechapelle.1.chapelle': 'Chapel',
      'donjon.1.antichambreconti': 'Anteroom ',
      'donjon.1.chambredumarechaldesaxe': 'Private bedchamber',
      'donjon.1.cabinetdesserte': 'Cabinet ',
      'donjon.1.cabinetgouverneur': 'Cabinet',
      'donjon.1.chambredugouverneur': 'Governor’s bedchamber ',
      'donjon.1.museecomtedechambord6': 'The Count of Chambord’s museum - 6',
      'donjon.2.theatredesaxe': 'Marshal of Saxony’s old theatre ',
      'donjon.2.sallevouteeouest': 'Vaulted hall – West',
      'donjon.2.sallevouteeest': 'Vaulted hall – East',
      'donjon.2.sallevouteesud': 'Vaulted hall – South',
      'donjon.2.salledexposition6': 'Exhibition room – 6',
      'donjon.2.salledexposition7': 'Exhibition room – 7',
      'donjon.2.salledexposition8': 'Exhibition room – 8',
      'donjon.2.salledexposition9': 'Exhibition room – 9',
      'donjon.2.salledexposition10': 'Exhibition room – 10',
      'donjon.2.loggiaest': 'East Loggia – 2nd floor',
      'donjon.2.salledexposition1': 'Exhibition room – 1',
      'donjon.2.salledexposition2': 'Exhibition room – 2',
      'donjon.2.salledexposition3': 'Exhibition room – 3',
      'donjon.2.salledexposition4': 'Exhibition room – 4',
      'donjon.2.salledexposition5': 'Exhibition room – 5',
      'ailechapelle.2.galeriedestrophees': 'Trophy gallery',
      'donjon.3.escaliernord': 'North staircase exit',
      'donjon.3.escaliersud': 'South staircase exit',
      'donjon.3.terrassesud': 'South Terrace',
      'donjon.3.terrasseest': 'East Terrace',
      'donjon.3.terrassenord': 'North Terrace',
      'donjon.3.terrasseouest': 'West Terrace',
    },
    'france.paris.conciergerie': {
      'accueil.0': 'Reception and ticket office',
      'sallegensdarmesest.0': 'The hall of Men at Arms - East',
      'grandesalleestsallegensdarmesest.0': 'Great Hall - East',
      'salledesgardes.0': 'Hall of the Guards',
      'cuisines.0': 'The kitchens',
      'sallegensdarmesouest.0': 'The hall of Men at Arms - West',
      'grandesalleouestsallegensdarmesouest.0': 'Great Hall - West',
      'parlementsalledesgardes.0': 'Parlement of Paris',
      'boutique.0': 'Shop',
      'cellulemarieantoinette.0': "Marie Antoinette's cell",
      'couloirdesprisonniers.0': 'The prisoners’ corridor',
      'salleexposition.0': 'The Revolution',
      'chapelledesgirondins.0': 'Chapel',
      'courdesfemmes.0': "Women's Courtyard",
      'toilets.0': 'Toilets',
      'alarm.0': 'Alarm',
      'salledescondamnes.1': 'Hall of Names',
      'couloirdesprisonniersentresol.1': 'The prisoners’ corridor - 1st floor',
      'museeprison.1': 'The Revolution and Justice',
    },
    'france.avignon.palais-des-papes': {
      'grandetresoreriehaute.-1': 'High Grand Treasury',
      'grandetresoreriebasse.-1': 'Low Grand Treasury',
      'tresorbas.-1': 'Lower treasury',
      'jardins.-1': 'Gardens',
      'accueil.0': 'Reception',
      'courhonneurouest.0': 'Main Courtyard',
      'courhonneurest.0': 'Main Courtyard',
      'courhonneurramp.0': 'Main Courtyard',
      'courcloitre.0': 'Courtyard of the Old Palace',
      'consistoire.0': 'Consistory Hall',
      'sallejesus.0': 'Jesus Hall',
      'revestiaire.0': 'Papal vestiary',
      'chambrecamerier.0': 'Former room of the Chamberlain',
      'escalierhonneurground.0': 'Ceremonial staircase',
      'grandeaudienceest.0': 'Great Audience - East',
      'grandeaudienceouest.0': 'Great Audience - West',
      'livredor.0': 'Reception',
      'courpalaisvieux.1': 'East upper Gallery',
      'grandtinelnord.1': 'Grand Tinel - North',
      'grandtinelsud.1': 'Grand Tinel - South',
      'cuisinehaute.1': 'High Kitchen',
      'chambreparement.1': 'Parement Chamber',
      'chambrepape.1': "Pope's Chamber",
      'chambrecerf.1': 'Stag Room',
      'sacristienord.1': 'North Sacristy',
      'grandechapelleest.1': 'Great Chapel',
      'revestiairecardinaux.1': "Cardinal's vestry",
      'grandechapelleouest.1': 'Great Chapel',
      'chambreneuvecamerier.1': 'New room of the Chamberlain',
      'escaliertourgache.1': 'La Gâche tower',
      'chambrenotaires.1': 'Notaries room',
      'loggia.1': 'Loggia - Indulgences Window',
      'escalierhonneur1stf.1': 'Ceremonial staircase',
      'coursivegrandsdignitaires.2': "Great Dignitaries' Passageway",
      'cafegrandsdignitaires.2': "Great Dignitaries' Café",
      'terrassegrandsdignitaires.2': "Great Dignitaries' Terrace",
      'toilettesgrandeaudience.0': 'Toilets Great Audience',
      'salleartillerie.0': 'Alarm',
    },
    'france.sainte-mere-eglise.airborne-museum': {
      'accueil.0.caisse': 'Reception, ticketing',
      'parc.0.sherman': 'Park',
      'waco.0.droite': 'WACO Building, glider',
      'waco.0.gauche': 'WACO Building, walkway',
      'parc.0.truck': 'Park',
      'c47.0': 'C-47 Building',
      'c47.0.gauche': 'C-47 Building - Entrance',
      'c47.0.droite': 'C-47 Building - Exit',
      'c47.0.videoroom': 'C-47 Building, video room',
      'c47.briefingroom': 'Briefing Room, England',
      'toilettes.0': 'Toilets',
      'accueil.0.boutique': 'Gift shop',
      'accueil.0.sortie': 'Exit',
      'parc.0.entreeneptune': 'Park',
      'reagan.0': 'Reagan Building',
      'neptune.0.sortie': 'Walkway to Reagan Building',
      'neptune.0.para': 'Operation Neptune Building, entrance',
      'neptune.0.sasstemere': 'Sainte-Mère-Eglise: the attack',
      'neptune.0.sme': 'Sainte-Mère-Eglise: D-Day',
      'neptune.0.lafiere': 'Kellam Bridge',
      'neptune.0.merderet': 'Kellam Bridge (part 2)',
      'neptune.0.haies': 'The "war of the hedgerows"',
      'neptune.0.toilettes': 'Toilets',
      'neptune.0.ambulance': 'Operation Neptune Building',
      'neptune.0.livredor': 'Visitors book',
      'c47.1.passerelle': 'C-47 Building, walkway',
      'c47.1.top': 'C-47 Building, overlook',
    },
    'france.blois.chateau': {
      'accueil.0': 'Entrance',
      'toilettes.0': 'Toilets',
      'boutique.0': 'Shop',
      'chapelle.0': 'The Saint-Calais Chapel',
      'cour.0.nord': 'Courtyard of Honour North',
      'cour.0.sud': 'Courtyard of Honour South',
      'cour.0.est': 'Courtyard of Honour East',
      'cour.0.ouest': 'Courtyard of Honour West',
      'accesfournisseur.0': 'Supplier access',
      'escaliersarchitecture.0': 'Staircase towards the Architecture Rooms',
      'escalierhonneur.0': 'The Gaston of Orleans Staircase of Honour',
      'guichet.0': 'Counter',
      'jardins.0': 'Marie de Medici Bastion',
      'terrassefoix.0': 'The terrace of the Foix Tower',
      'cour.0.livredor': 'Visitors book',
      'architecture1.0': 'Architecture Room no. 1',
      'architecture2.0': 'Architecture Room no. 2',
      'architecture3.0': 'Architecture Room no. 3',
      'architecture4.0': 'Architecture Room no. 4',
      'etatsgeneraux.0': 'The Estates Room',
      'interpretation1.0': 'Display Room 1',
      'interpretation2.0': 'Display Room 2',
      'interpretation3.0': 'Display Room 3',
      'tourdumilieu.0': 'The Middle Tower',
      'gastonalarm.1': 'Alarm',
      'chambrereine.1': "The Queen's Chamber",
      'gastonexpo1.1': 'Exhibition room 1',
      'gastonexpo2.1': 'Exhibition room 2',
      'gastonexpo3.1': 'Exhibition room 3',
      'galeriereine.1': "The Queen's Gallery",
      'galeriepaysage.1': 'The Landscapes Gallery',
      'galerietapisserie.1': 'The Tapestry Gallery',
      'garderobe.1': 'The Garderobe',
      'oratoire.1': 'The Oratory',
      'salleblois.1': 'The Blois Room',
      'salleviergeenfant.1': 'The Virgin and Child Room',
      'sallechateaux.1': 'The Châteaux Room',
      'sallehistoires.1': 'The History Room',
      'sallepetitsformats.1': 'The Small Formats Room',
      'salleportraits.1': 'The Portraits Room',
      'sallesalons.1': 'The Salons Room',
      'sallevalois.1': 'The Valois Room',
      'salleroi.1': "The King's Room",
      'studiolo.1': 'The Studiolo',
      'galeriebelvedere.2': 'The Garden Viewpoint Gallery',
      'cabinetetiquette.2': 'The Cabinet of Etiquette',
      'cabinetguerrereligions.2': 'The Cabinet of the French Wars of Religion',
      'cabinetneuf.2': 'The New Cabinet',
      'chambreroi.2': "The King's Chamber",
      'galerieduban.2': 'The Duban Gallery',
      'salleconseil.2': 'The Council Chamber',
      'salleneorenaissance.2': 'The Neo-Renaissance Room',
    },
    'france.la-mongie.pic-du-midi': {
      'chambres.-1': 'Rooms',
      'accueil.0': 'Reception',
      'galeriepanorama.0': 'Panorama gallery',
      'terrasse.0': 'Pic du Midi terrace',
      'maquette.0': 'Maquette room',
      'experiences.1': 'Experiences space',
      'cieletoile.1': 'Sky reserve',
      'merveilles.2': 'Gallery of Marvels',
      'planetarium.2': 'Planetarium',
      'bistrot.0': 'Bistro',
      'restaurant.-1': 'Restaurant',
      'sortienord.0': 'North exit',
      'sortiesud.0': 'South exit',
      'terrassetoilets.0': 'Toilets',
      'maquettetoilets.0': 'Toilets',
    },
    'france.loches.donjon': {
      'accueil.0': 'Reception room',
      'palier.0': 'Landing',
      'cachotbalue.-1': "Cardinal Balue's dungeon",
      'excentriques.1': 'Dungeon of Eccentricities',
      'sallegardes.1': "Guard's Quarters",
      'celluleduc.2': "The Duke of Allençon's Cell",
      'PlaceTitle.Map.LogisGeolier': "Jailer's lodge",
      'rebelles.2': 'Rebel Dungeon',
      'courdonjon.0': 'Courtyard of the Keep',
      'PlaceTitle.Map.Martelet': 'Tour du Martelet',
      'sallesforza.-1': "Sforzesca's Room",
      'cachotsforza.-2': "Ludovico Sforza's Cell",
      'cachoteveques.-3': "Bishops' Dungeon",
      'carriere.-4': 'Quarry',
      'courchateauwest.0': 'Castle Courtyard (west)',
      'courchateaueast.0': 'Castle Courtyard (east)',
      'tourabec.0': 'Tower',
      'jardinmedieval.0': 'Medieval garden',
      'PlaceTitle.Map.Donjon': 'Keep',
      'cellier.0': 'Cellar',
      'grandesalle.1': 'Great Hall',
      'chambrecomptale.2': "Count's Chamber",
      'chapelle.2': 'Chapel',
      'niveaudefensif.3': 'Defensive Level',
      'tourporte.0': 'Tower Door',
      'tourporte.1': 'Tower Door',
      'donjon.0': 'Staircase of the keep',
      'tourneuve.0': 'Room A place a history',
      'terrasse.3': 'Terrace',
      'toilets.0': 'Toilets',
    },
    'france.amboise.chateau': {
      'accueil.-1': 'Reception and ticket office',
      'rampe.-1': 'Ramp access to the castle',
      'rampeorangerie.-1': 'Ramp access to the castle',
      'alleessw.1': 'Gardens: the alleys (south-west)',
      'alleesse.1': 'Gardens: the alleys (south-east)',
      'alleesne.1': 'Gardens: the alleys (north-east)',
      'alleesnw.1': 'Bust of Leonardo da Vinci',
      'alleessudouest.1': 'Gardens: the alleys (south-west)',
      'alleessudest.1': 'Gardens: the alleys (south-east)',
      'alleesnordest.1': 'Gardens: the alleys (north-east)',
      'alleesnordouest.1': 'Bust of Leonardo da Vinci',
      'cabinetorleans.2': 'The Orléans-Penthièvre Cabinet',
      'chambreorleans.2': 'The Orléans Bedroom',
      'chambreroi.1': "The King's Bedroom",
      'chapelle.0': 'Saint-Hubert Chapel',
      'aumale.1': 'The Aumale Galerie',
      'garderobe.1': 'The Garderobe',
      'grandechambre.1': 'The Great Bedroom',
      'grandesalle.1': 'The Great Hall',
      'naplesouest.1': 'The Naples Garden (west)',
      'naplesest.1': 'The Naples Garden (east)',
      'jardinorient.1': 'The Orient Garden',
      'jardinmidi.1': 'The South Garden',
      'portelions.1': 'Lions Gate',
      'orangerie.-1': 'Orangerie: café and WC',
      'promenoir.0': 'The Guards Walkway',
      'minimes.1': 'The Cavalier Ramp',
      'sallegardes.0': 'The Guard Room',
      'pilier.0': 'The Pillar Room',
      'tambourineurs.1': 'The Drummers Room',
      'salonmusique.2': 'The Music Room',
      'minimes.2': 'Roof of the Minimes Tower',
      'terrassesnord.0': 'Terraces (north)',
      'terrassessud.0': 'Terraces (south)',
      'terrassesup.1': 'Upper terrace',
      'tourheurtault.-1': 'The Heurtault Tower',
      'courheurtault.-1': 'The Heurtault court',
      'boutique.-1': 'Shop',
    },
    'france.chinon.forteresse': {
      'accueil.0.accueil': 'Reception, Ticketing, Gift Shop',
      'acceschateau.0': 'Castle access',
      'accueil.0.toilettes': 'Toilets',
      'alarm.0.rampe': 'Rampe alarm',
      'alarm.0.parking': 'Parking alarm',
      'rampeacces.0': 'Castle access (rampe)',
      'argenton.-3': 'Argenton Tower, basement level 3',
      'argenton.-2': 'Argenton Tower, basement level 2',
      'argenton.-1': 'Argenton Tower, basement level 1',
      'argenton.0': 'Argenton Tower, terrace',
      'chiens.-2': 'Dogs Tower, basement level 2',
      'chiens.-1': 'Dogs Tower, basement level 1',
      'chiens.0': 'Dogs Tower, ground floor',
      'chiens.1': 'Dogs Tower, terrace',
      'boissy.-1': 'Boissy Tower, basement level 1',
      'boissy.0': 'Boissy Tower, ground floor',
      'horloge.0': 'Clock Tower, ground floor',
      'horloge.1': 'Clock Tower, level 1',
      'horloge.2': 'Clock Tower, level 2',
      'horloge.3': 'Clock Tower, level 3',
      'horloge.4': 'Clock Tower, level 4',
      'horloge.5': 'Clock Tower, walkway',
      'coudray.-1': 'Coudray Tower, basement level 1',
      'coudray.0': 'Coudray Tower, ground floor',
      'coudray.1': 'Coudray Tower, level 1',
      'coudray.2': 'Coudray Tower, level 2',
      'moulin.0': 'Mill Tower, ground floor',
      'fortdumilieu.0.toilettes': 'Toilets',
      'forteresse.0.aula': 'Plantagenet Hall',
      'forteresse.0.archeo': 'History and Archeology Hall',
      'forteresse.0.dependances': 'Kitchens, room 2',
      'forteresse.0.cuisine': 'Kitchens, room 1',
      'fortdumilieu.0.bombarde': 'Fortress Park',
      'fortdumilieu.0.sallereco': 'Fortress Park',
      'fortdumilieu.0.chapellesud': 'Fortress Park (south chapel)',
      'fortdumilieu.0.chapellenord': 'Fortress Park (north chapel)',
      'fortdumilieu.0.cafe': 'Snack Bar - Hot Coffee and Tea',
      'fortducoudray.0.courtourcoudray': 'Coudray Fort, courtyard',
      'fortducoudray.0': 'Coudray Fort',
      'forteresse.1.marieanjou': 'Joan of Arc Hall of engravings, etchings, and prints',
      'forteresse.1.jeannedarc': 'Joan of Arc Collection Hall',
      'forteresse.1.parement': 'Charles VII Chamber of Adornment',
      'forteresse.1.charlesvii': 'Charles VII Retirement Room',
      'accueil.2.terrasse': 'Saint George Fort, terrace',
    },
    'france.gordes.senanque': {
      'accueil.1': 'Reception/Ticketing',
      'boutique.0': 'Abbey gift shop',
      'maquette.1': 'Model room',
      'dortoir.1': 'Dormitory',
      'abbatiale.0': 'Abbey church',
      'cloitre.0': 'Cloister',
      'chauffoir.0': 'Calefactory',
      'chapitre.0': 'Chapter room',
      'refectoire.0': 'Chapel/Refectory',
      'toilets.0': 'Toilettes',
      'alarme.0': 'Alarm',
      'entree.0': 'Entrance',
      'retourhistopad.0': 'HistoPad returns',
    },
    'france.paris.pcv': {
      alma: "La place de l'alma",
      arcdetriomphe: 'The Arc of Triumph',
      assembleenationale: 'The National Assembly',
      avenueopera: "L'avenue de l'Opéra",
      beauxarts: 'The École nationale supérieure des Beaux-Arts',
      bouquiniste: 'The Bouquinistes of Paris',
      champselysees1: 'The Avenue des Champs-Elysées',
      champselysees2: 'The Champs-Elysées',
      comediefrancaise: 'Comédie Française - French National Theatre',
      conciergerie: 'The Conciergerie',
      concorde: 'Place de la Concorde',
      hdv: 'City Hall',
      immeublehaussmanien: 'A Typical Haussmann Building',
      institutdefrance: 'The Institut Français',
      invalides: 'The Dome of the Invalides',
      kiosquepcv: 'Our offers',
      kiosquepcvtuileries: 'Our offers - Tuileries',
      lido: 'The Lido',
      louvre: 'The Louvre, after Louis XIV',
      louvremedieval: 'Foundation of the Louvre fortresss',
      louvretoday: 'The Louvre Museum',
      luxembourg: 'Luxembourg Gardens',
      museebranly: 'The Quai Branly - Jacques Chirac Museum',
      notredame: 'The Cathedral of Notre Dame',
      opera: 'Garnier Opera House',
      orsay: 'Orsay Museum',
      palaistokyo: 'Palais de Tokyo',
      pantheon: 'The Pantheon',
      pcvstart: 'PCV start',
      placevendome: 'La place Vendôme',
      quartierelysee: 'Neighborhood of the Presidential Palace',
      saintgermaindespres: 'Saint-Germain-des-Prés',
      saintsulpice: 'The Church of Saint-Sulpice, Paris',
      sorbonne: 'Sorbonne University',
      stopbateaux: 'Cruise stop and Eiffel Tower',
      toureiffel: 'Eiffel Tower View',
      trocadero: 'The Trocadéro',
      tuileries: 'The Tuileries Garden',
      tutorials: 'Tutorial',
      pcvend: 'PCV end',
    },
    'france.arcetsenans.saline': {
      'accueil.0': 'Tickets',
      'exterieuraccueil.0': 'Courtyard',
      'hallmaisondirecteur.0': 'Vestibule',
      'museeselsalle1.0': 'Salt museum - Room 1 ',
      'museeselsalle2.0': 'Salt museum - Room 2',
      'museeselsalle3.0': 'Salt museum - Room 3',
      'museeselsalle4.0': 'Vestibule',
      'museeselsalle5.0': 'Salt museum - Room 5',
      'museeselsalle6.0': 'Salt museum - Room 6',
      'berneouest.0': 'Western Boilerhouse',
      'tonnellerieentree.0': 'Auditorium',
      'tonnelleriemusee.0': 'Ledoux museum - Built work',
      'tonnelleriemusee.galerieledoux.0': 'Ledoux museum - Built work',
      'tonnelleriemusee.filmguimard.0': 'Ledoux museum - Built work',
      'tonnelleriemusee.filmbesancon.0': 'Ledoux museum - Built work',
      'tonnelleriemusee.filmsaline.0': 'Ledoux museum - Built work',
      'tonnelleriemusee.filmthelusson.0': 'Ledoux museum - Built work',
      'tonnelleriemusee.galerieprojets.0': 'Ledoux museum - Projects',
      'bernierest.0': 'Eastern briners',
      'bernierest.cuisine.0': 'Eastern briners',
      'bernierest.jardins.0': 'The gardens',
      'exterieurmuseesel.0': 'Courtyard',
      'exterieurnord.0': 'Courtyard',
      'exterieurouest.0': 'Courtyard',
      'exterieursudouest.0': 'Courtyard',
      'exterieursudest.0': 'Courtyard',
      'exterieurest.0': 'Courtyard',
      'paliermaisondirecteur.1': 'First floor landing',
      'tonnellerieetage.1': 'Ledoux museum - Paris toll barriers',
      'toilettesberneest.0': 'Toilets Eastern briners',
      'boutique.0': 'Shop',
      'alarm.0': 'Alarm',
    },
    'deutschland.meissen.albrechtsburg': {
      'basementhall.-1': 'Cellar Hall',
      'sludgecellarvestibule.-1': 'Anteroom to the Sludge Cellar',
      'staircase.-1': 'Staircase',
      'reception.0': 'Foyer - Shop - Café',
      'cloakroom.0': 'Cloakroom',
      'specialexhibitionarea.0': 'Special Exhibitions Area',
      'littlespiralstaircase.0': 'Small Spiral Staircase',
      'largehall.1': 'Large Hall',
      'largecourthall.1': 'Large Court Hall',
      'smalldiningroom.1': 'Small Dining Room',
      'firstelectorsroom.1': "Elector's First Room",
      'secondelectorsroom.1': "Elector's Second Room",
      'chapel.1': 'Chapel',
      'smallroom.1': 'Small Hall Room',
      'littlespiralstaircase.1': 'Small Spiral Staircase',
      'largespiralstaircase.1': 'Large Spiral Staircase',
      'largestaircaseantechamber.2': 'Entrance Hall by the Large Spiral Staircase',
      'bottgerroom.2': 'Boettger Room',
      'smallappellationroom.2': 'Small Appellation Room',
      'largeappellationroom.2': 'Large Appellation Room',
      'electoraugustsroom.2': 'Elector August Room',
      'heraldichall.2': 'Heraldic Hall',
      'spiralstaircaseroom.2': 'Spiral Staircase Room',
      'largeappellationroomchamber.2': 'Chamber next to the Large Appellation Room',
      'oldduchesschamber.2': 'Chamber of the Old Duchess',
      'spiralstaircasechamber.2': 'Spiral Staircase Chamber',
      'chapel.2': 'Chapel Tower Room',
      'ladieschamber.2': "Ladies' Chamber",
      'smallspiralstaircaseantechamber.2': 'Entrance Hall by the Small Spiral Staircase',
      'littlespiralstaircase.2': 'Small Spiral Staircase',
      'largespiralstaircase.2': 'Large Spiral Staircase',
      'ladiesroom1.3': "Ladies' Chamber 1",
      'chamberbytheladiesrooms.3': "Room next to the Ladies' Chamber",
      'ladiesroom2.3': "Ladies' Chamber 2",
      'ladiesroom3.3': "Ladies' Chamber 3",
      'ladiesroom4.3': "Ladies' Chamber 4",
      'chamberinfrontofladiesrooms.3': "Room Across from the Ladies' Chamber",
      'menschamber.3': "Men's Chamber",
      'chapel.3': 'Nightingale Room',
      'largestaircaseantechamber.3': 'Entrance Hall by the Large Spiral Staircase',
      'spiralstaircaseroom.3': 'Spiral Staircase Room',
      'spiralstaircasechamber.3': 'Spiral Staircase Chamber',
      'councilchamber.3': 'Council Room',
      'chambertocouncilroom.3': 'Chamber to the Council Room',
      'littlespiralstaircase.3': 'Small Spiral Staircase',
      'largespiralstaircase.3': 'Large Spiral Staircase',
      'toilets.-1': 'Toilets',
    },
    'deutschland.moritzburg.schlossmoritzburg': {
      'entrancehall.0': 'Entrance Hall',
      'anteroomtofeatherroom.0': 'Anteroom to Feather Room',
      'exhibitionroom.0': 'Exhibition Rooms',
      'featherroom.0': 'Feather Room',
      'entrancehall.0.timegate1945': 'Entrance Hall',
      'entrancehall.0.timegateguestbook': 'Entrance Hall',
      'toilets.0': 'Toilets',
      'shop.0': 'Shop',
      'restaurant.0': 'Restaurant',
      'reception.0': 'Reception',
      'stonehall.1': 'Stone Hall',
      'stonehall.1.timegateselfie': 'Stone Hall',
      'monstroushall.1': 'Monstrous Hall',
      'palacechapel.1': 'Chapel',
      'dininghall.1': 'Dining Hall',
      'billiardhall.1': 'Billiard Hall',
      'furnitureroom.1': 'Apartment for Members of the Royal Family, Room 2',
      'augustroom1.1': 'Apartment of King August the Strong, Room 1',
      'augustroom2.1': 'Apartment of King August the Strong, Room 2',
      'ladiesportraitsroom.1': 'Apartment of Electoral Princess Maria Josepha, Room 3',
      'guestroom2.1': 'Apartment of Electoral Princess Maria Josepha, Room 1',
      'electorroom1.1': 'Apartment of Electoral Prince Friedrich August, Room 1',
      'electorroom2.1': 'Apartment of Electoral Prince Friedrich August, Room 2',
      'bruhlroom.1': 'Apartment of Electoral Prince Friedrich August, Room 3',
    },
    'germany.colditz.schloss-colditz': {
      'guardhouse.0.welcomearea': 'Welcome area',
      'chapel.0': 'Chapel wing',
      'electorshouse.0.displaydepot': "Ground Floor of the Elector's House",
      'electorshouse.0.silverchamber': 'Silver Chamber',
      'courtyard.0': 'Rear Castle Courtyard',
      'guardhouse.1.chamber': 'The Guardroom',
      'cellar.1.banquetroom': 'Banquet Room',
      'cellar.1.anteroom': 'Anteroom',
      'cellar.1.huntingroom': 'Hunting Room',
      'cellar.1.storeroom': 'Lower Parlour',
      'chapel.1.gallery': 'Chapel Gallery',
      'chapel.2.bath': 'Escape Museum I',
      'chapel.3.womanapartments': 'Escape Museum II',
      'chapel.4.gliderloft': 'Escape Museum III',
    },
  },
}
